<template>
  <div class="dlrVRBottomMenu-pop">
    <div class="dlrVRBottomMenu-pop-bg">
      <a class="dlrVRBottomMenu-pop-close" @click="hide"></a>
      <div class="dlrVRBottomMenu-pop-flex">
        <div class="dlrVRBottomMenu-pop-nav">
          <ul>
            <li :class="{current: indexNumber === 1}">
              <a @click="select(1)">
                <span>{{saleCarInfo.seriesName}}优惠</span>
              </a>
            </li>
            <li :class="{current: indexNumber === 2}" v-if="ActivityPacketAllList.length>0">
              <a @click="select(2)">
                <span>店内优惠</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="dlrVRBottomMenu-pop-scroll">
          <div class="salesPop-box">
            <div id="spcList" class="salesPop-styles">
              <div class="salesPop-coupons" v-if="ActivityPacketList.length>0">
                <ul>
                  <li v-for="(item, i) in ActivityPacketList" :key="i">
                    <div class="salesPop-coupon" :class="{ gray: item.isSend }">
                      <div class="salesPop-coupon-text">
                        <h4>
                          <span>{{ item.amount }}</span><em>元{{ item.redPacketsTypeName }}</em>
                        </h4>
                      </div>
                      <p>
                        <a
                          class="salesPop-btn"
                          href="javascript:void(0);"
                          v-stat:show="{ action: 'dlr_vr_b_fasonghongbao_show', extend: { channelId }}"
                          v-stat:click="{ action: 'dlr_vr_b_fasonghongbao_click', extend: { channelId } }"                          
                          @click="redPackSendUser(item, 1)"
                        >
                          <span v-if="item.isSend">已发给客户</span>
                          <span v-else>发给客户</span>
                        </a>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
               <div v-if="specList.length>0">
                <div class="salesPop-style-item" v-for="spec in specList" :key="spec.specId">
                  <h4>{{spec.specName}}</h4>
                  <div class="salesPop-style-price">
                      <p v-if="filterNumber(spec.maxPrice)>0">
                        <span>店内报价</span>
                        <em class="font-orange">{{formatPlayNum(spec.maxPrice)}}</em>
                      </p>
                      <p v-if="sub(spec.maxPrice, spec.newsPrice)>0">
                      <span>降价</span>
                      <em class="font-green">{{sub(spec.maxPrice, spec.newsPrice)}}</em>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="dlrVRBottomMenu-pop-box" v-if="ActivityPacketAllList.length>0">
               <div class="dlrVRBottomMenu-pop-title mt30">
                <p>店内优惠</p>
              </div>
              <div class="salesPop-seires">
                <div class="salesPop-coupons">
                  <ul>
                    <li  v-for="(item, i) in ActivityPacketAllList" :key="i">
                      <div class="salesPop-coupon" :class="{ gray: item.isSend }">
                        <div class="salesPop-coupon-text">
                          <h4>
                            <span>{{ item.amount }}</span><em>元{{ item.redPacketsTypeName }}</em>
                          </h4>
                          <h5 v-if="item.allSeriesFlag === 1">适用于全车系</h5>
                          <h5 v-else>
                            适用于{{ filterSeriesName(item.seriesNames) }}
                          </h5>
                        </div>
                        <p>
                          <a
                            class="salesPop-btn"
                            href="javascript:void(0);"
                            @click="redPackSendUser(item, 2)"
                            v-stat:show="{ action: 'dlr_vr_b_fasonghongbao_show', extend: { channelId }}"
                            v-stat:click="{ action: 'dlr_vr_b_fasonghongbao_click', extend: { channelId } }"                          
                          >
                            <span v-if="item.isSend">已发给客户</span>
                            <span v-else>发给客户</span>
                          </a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrVRBottomMenu-pop-mask"></div>
  </div>
</template>
<script>
import 'intersection-observer';
import { mapGetters } from 'vuex';
import util from '@/utils/util';
import layerManager from '@/services/layer.manager';
import redPacketsProxy from '@/services/actionSync/red.packet.proxy';
import eventBus from '@/services/eventBus.service';
let targNode = null;
export default {
  props: {
    ActivityPacketList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    ActivityPacketAllList:{
      type: Array,
      default: function () {
        return [];
      }
    },
    specList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    saleCarInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters({
      vrSalesInfo: 'sales/vrSalesInfo',
      baseInfo: 'baseInfo'
    }),
    channelId () {
      return this.vrSalesInfo.channelId;
    },
    dealerId () {
      return this.baseInfo.dealerId;
    }
  },
  data () {
    return {
      indexNumber: 1,
      observer: null,
      redBag: null,
    };
  },
  created () {
    eventBus.$on('redPackcollect', ({
      promotionId,
      redPacketsTypeId,
      typeId
    }) => {
      if (typeId === 1) {
        this.redBag = this.ActivityPacketList.find(
          (red) =>
            red.promotionId === promotionId &&
            red.redPacketsTypeId === redPacketsTypeId,
        );
      } else {
        this.redBag = this.ActivityPacketAllList.find(
          (red) =>
            red.promotionId === promotionId &&
            red.redPacketsTypeId === redPacketsTypeId,
        );
      }
      if (this.redBag) {
        this.redBag.isSend = true;
      }
    });
  },
  methods: {
    formatPlayNum (val) {
      return util.numFormat(val, 1);
    },
    filterSeriesName(SeriesNameList) {
      return SeriesNameList.join('/');
    },
    filterNumber(n){
      if (typeof n === 'undefined' || n === null) {
        return 0;
      }
      return n;
    },
    sub(beforeNumber,afterNumber) {
      const n1 = this.filterNumber(beforeNumber);
      const n2 = this.filterNumber(afterNumber);
      if (n2 === 0 || n1 === 0 || n1 < n2) {
        return 0;
      }
      return n1 - n2;
    },
    style () {
      return {
        hidden: function(scrollElement){
          scrollElement.style.overflowY = 'hidden';
        },
        auto: function (scrollElement) {
          scrollElement.style.overflowY = 'auto';
        }
      }
    },
    select (i) {
      const scrollElement = document.getElementsByClassName('dlrVRBottomMenu-pop-scroll')[0]
      this.indexNumber = i;
      this.style().hidden(scrollElement);
      this.scrollTop(i, scrollElement);
    },
    scrollTop(i, scrollElement) {
      var spcListElement = document.getElementById('spcList');
      var spcListElementHeight = spcListElement.clientHeight;
      if (i === 1) {
        scrollElement.scrollTop = 0;
      } else {
        scrollElement.scrollTop = spcListElementHeight;
      }
       this.style().auto(scrollElement);
    },
    beforeDestroy() {
      if (targNode) {
        this.observer.unobserve(targNode);
      }
    },
    ob () {
      const self = this;
      targNode = document.querySelector('.dlrVRBottomMenu-pop-box');
      if (!targNode) {
        return;
      }
      const options = {
        root: document.querySelector('.dlrVRBottomMenu-pop-scroll'),
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            self.indexNumber = 2;
          } else {
            self.indexNumber = 1;
          }
        });
      }, options);
      this.observer.observe(targNode);
    },
    hide () {
      this.$emit('hide');
    },
    redPackSendUser (redPacket, typeId) {
      if (redPacket.isSend) {
        layerManager.toast({ propsData: { message: '已发给客户！' } }, 2000);
        return;
      }
      if (redPacketsProxy.opened) {
        layerManager.toast({ propsData: { message: '红包弹层还未关闭，请稍后发送！' } }, 2000);
        return;
      }
      redPacketsProxy.showRedPackets({
        isRemote: false,
        promotionId: redPacket.promotionId, // 红包id
        seriesId: this.saleCarInfo.seriesId,
        redPacketsTypeId: redPacket.redPacketsTypeId,
        dealerId: this.dealerId,
        typeId,
      });
    }
  },
  watch: {
    ActivityPacketAllList: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.ob();
          });
        }
      },
      immediate: true
    }
  }
};
</script>
